var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHubCarouselPowerlinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9271_2661)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 5.33333C28 4.97971 27.8595 4.64057 27.6095 4.39052C27.3594 4.14048 27.0203 4 26.6667 4H20C19.6464 4 19.3072 4.14048 19.0572 4.39052C18.8071 4.64057 18.6667 4.97971 18.6667 5.33333C18.6667 5.68696 18.8071 6.02609 19.0572 6.27614C19.3072 6.52619 19.6464 6.66667 20 6.66667H23.448L20.6347 9.48C21.3644 9.99818 22.0021 10.635 22.5213 11.364L25.3333 8.552V12C25.3333 12.3536 25.4738 12.6928 25.7239 12.9428C25.9739 13.1929 26.313 13.3333 26.6667 13.3333C27.0203 13.3333 27.3594 13.1929 27.6095 12.9428C27.8595 12.6928 28 12.3536 28 12V5.33333ZM20.6347 9.48C19.282 8.5153 17.6614 7.99781 16 8H6.66667C5.95942 8 5.28115 8.28095 4.78105 8.78105C4.28095 9.28115 4 9.95942 4 10.6667V25.3333C4 26.0406 4.28095 26.7189 4.78105 27.219C5.28115 27.719 5.95942 28 6.66667 28H21.3333C22.0406 28 22.7189 27.719 23.219 27.219C23.719 26.7189 24 26.0406 24 25.3333V16C24 14.272 23.4533 12.672 22.52 11.364L14.276 19.6093C14.0245 19.8522 13.6877 19.9866 13.3381 19.9836C12.9885 19.9805 12.6541 19.8403 12.4069 19.5931C12.1597 19.3459 12.0195 19.0115 12.0164 18.6619C12.0134 18.3123 12.1478 17.9755 12.3907 17.724L20.636 9.47867L20.6347 9.48Z",
    fill: "#CA2C31"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9271_2661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubCarouselPowerlinks);
export default __webpack_public_path__ + "static/media/hub-carousel-powerlinks.259116f34b0110f4175b4cdeb0fc0392.svg";
export { ForwardRef as ReactComponent };